export default __webpack_public_path__ + "static/16_33-5eb77659b68da20260a297c9a10e15d2.png";